<template>
  <div class="candidates">
    <div v-if="!loading">
      <div v-if="candidatesArray.length > 0" class="row">
        <div
          class="candidate"
          :key="index"
          v-for="(candidate, index) in candidatesArray"
        >
          <applicant-synopsis
            :key="change"
            v-bind:candidate="candidate"
            v-bind:subjects="subjects"
            v-bind:type="type"
            v-bind:job_id="jobID"
            v-bind:job="job"
            v-bind:company_id="company_id"
            v-on:favourite="onClickFavourite"
            v-on:cancel-favourite="onClickCancelFavourite"
            v-on:reject="onClickReject"
            v-on:cancel-reject="onClickCancelReject"
          ></applicant-synopsis>
        </div>
      </div>
    </div>
    <div  v-else style="height: 90vh;">
      <!-- <v-progress-circular
        :size="100"
        :width="3"
        color="#3555DF"
        indeterminate
      ></v-progress-circular> -->
      <loader></loader>
    </div>
    <v-snackbar :color="bgColor" :timeout="timeOut" top v-model="snackbar">
      <div style="text-align: center; width: 100%">
        <span style="padding-right:1.0rem"
        ><v-icon color="rgba(0,0,0,0.5)">{{ snackIcon }}</v-icon></span
        >{{ snackMessage }}
      </div>
    </v-snackbar>
  </div>
</template>

<script>
import ApplicantSynopsis from "./applicant-synopsis";
import { ADD_OR_REMOVE_APPLICANTS } from "../../../Api/employer_api";
import { GET_MESSAGE_SUBJECT } from "../../../Api/common_api";
import Loader from "../../global-components/loader"
export default {
  name: "applicant-list",
  components: {
    ApplicantSynopsis,
    Loader
  },
  props: {
    candidates: Array,
    job_id: String,
    type: String,
    job: Object,
    company_id: String
  },
  data: function() {
    return {
      jobID: null,
      candidatesArray: [],
      change: 0,
      subjects: [],
      loading: false,
      bgColor: "#454545",
      timeOut: 1500,
      snackbar: false,
      snackIcon: "",
      snackMessage: "",
      ripple: false,
    };
  },
  methods: {
    getIndexNumber(items, id) {
      let i;
      for (i = 0; i < items.length; i++) {
        if (items[i].user_id === id) return i;
      }
      return -1;
    },
    onClickFavourite(id) {
      const self = this;
      self.loading = true;
      let data = {
        job_id: self.jobID,
        action_type: 1,
        user_id: id
      };
      ADD_OR_REMOVE_APPLICANTS(data, "add")
        .then(function(response) {
          if (response.status === 200) {
            let index = self.getIndexNumber(self.candidates, id);
            self.candidates.splice(index, 1);
            if(self.candidates.length <= 0) {
                self.$emit('fetch-candidates', 'all', true);
            } else {
                self.$emit('update-count', 'add', 'fav');
                self.change++
            }
            self.loading = false;
          }
        })
        .catch(function(err) {
          self.loading = false;
          self.snackbar = true;
          self.snackIcon = self.$constants.SNACKBAR_ICON.ERROR;
          self.bgColor = self.$constants.SNACKBAR_COLOR.ERROR;
          self.snackMessage = err.message;
        });
    },
    onClickCancelFavourite(id) {
      const self = this;
      self.loading = true;
      let data = {
        job_id: self.jobID,
        action_type: 1,
        user_id: id
      };
      ADD_OR_REMOVE_APPLICANTS(data, "remove")
        .then(function(response) {
          if (response.status === 200) {
            let index = self.getIndexNumber(self.candidates, id);
            self.candidates.splice(index, 1);
            if(self.candidates.length <= 0) {
                self.$emit('fetch-candidates', 'fav', true);
            } else {
                self.$emit('update-count', 'rem', 'fav');
                self.change++
            }
            self.loading = false;
          }
        })
        .catch(function(err) {
          self.loading = false;
          self.snackbar = true;
          self.snackIcon = self.$constants.SNACKBAR_ICON.ERROR;
          self.bgColor = self.$constants.SNACKBAR_COLOR.ERROR;
          self.snackMessage = err.message;
        });
    },
    onClickReject(id) {
      const self = this;
      self.loading = true;
      let data = {
        job_id: self.jobID,
        action_type: 2,
        user_id: id
      };
      ADD_OR_REMOVE_APPLICANTS(data, "add")
        .then(function(response) {
          if (response.status === 200) {
            let index = self.getIndexNumber(self.candidates, id);
            self.candidates.splice(index, 1);
            if(self.candidates.length <= 0) {
                self.$emit('fetch-candidates', 'all', true);
            } else {
                self.$emit('update-count', 'add', 'rej');
                self.change++
            }
            self.loading = false;
          }
        })
        .catch(function(err) {
          self.loading = false;
          self.snackbar = true;
          self.snackIcon = self.$constants.SNACKBAR_ICON.ERROR;
          self.bgColor = self.$constants.SNACKBAR_COLOR.ERROR;
          self.snackMessage = err.message;
        });
    },
    onClickCancelReject(id) {
      const self = this;
      self.loading = true;
      let data = {
        job_id: self.jobID,
        action_type: 2,
        user_id: id
      };
      ADD_OR_REMOVE_APPLICANTS(data, "remove")
        .then(function(response) {
          if (response.status === 200) {
            let index = self.getIndexNumber(self.candidates, id);
            self.candidates.splice(index, 1);
            if(self.candidates.length <= 0) {
                self.$emit('fetch-candidates', 'rjct', true);
            } else {
                self.$emit('update-count', 'rem', 'rej');
                self.change++
            }
            self.loading = false;
          }
        })
        .catch(function(err) {
          self.loading = false;
          self.snackbar = true;
          self.snackIcon = self.$constants.SNACKBAR_ICON.ERROR;
          self.bgColor = self.$constants.SNACKBAR_COLOR.ERROR;
          self.snackMessage = err.message;
        });
    },
    compare(a, b) {
      const A = a.score_flat;
      const B = b.score_flat;

      let comparison = 0;
      if (A > B) {
        comparison = -1;
      } else if (A < B) {
        comparison = 1;
      }
      return comparison;
    }
  },
  mounted() {
    const self = this;
    if (self.candidates) {
      self.candidatesArray = self.candidates.sort(self.compare);
      self.jobID = self.job_id;
      if(!self.company_id){
          GET_MESSAGE_SUBJECT()
              .then(function(data) {
                  self.subjects = data;
              })
              .catch(function() {
                  self.subjects = [];
              });
      }
    }
  }
};
</script>

<style scoped>
.candidates {
  margin: auto;
}
.candidate {
  padding: 0.5rem;
  width: 100%;
}
.no-result {
  margin-top: 5.5rem !important;
  padding: 10vh 0;
  height: 60vh;
}
.no-result-color {
  color: #bbbec1;
}
@media (max-width: 600px) {
  .candidates {
    padding: 0rem 0rem;
  }
}
</style>
